import {Component, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";
@Component({
  selector: 'micro-ussdSvcCode-detail',
  templateUrl: './ussdSvcCode-detail.component.html'
})
export class UssdSvcCodeDetailComponent implements OnInit {
  ussdSvcCode:any;
  ussdUsers:any[];

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
  }

  ngOnInit() {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/ussd/ussdSvcCodes/${id}`).subscribe(
            data => {
              this.setUssdSvcCode(data)
            }
          );
          this.http.get(`${this.env.e.url}/ussd/ussdSvcCodes/ussdUsers`).subscribe(
            data => {
              this.ussdUsers = data as any[];
            }
          );
        }
      });
  }

  setUssdSvcCode(ussdSvcCode:any) {
    this.ussdSvcCode = ussdSvcCode;
  }

  createNew() {
    this.ussdSvcCode = {
      callbackUrl: undefined,
      errorRspMessage: "Internal Error",
      ratingType: 'STANDARD',
      useChatApp: false,
      useSubscriptionService: false,
      ussdUsers: []
    };
  }

  save() {
    if (!this.ussdSvcCode.id) {
      this.http.post(`${this.env.e.url}/ussd/ussdSvcCodes`, this.ussdSvcCode)
        .subscribe(
          data => {
            this.setUssdSvcCode(data)
            this.alertService.info(`Created ${this.ussdSvcCode.svcCode}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/ussd/ussdSvcCodes/${this.ussdSvcCode.id}`, this.ussdSvcCode)
        .subscribe(
          data => {
            this.setUssdSvcCode(data)
            this.alertService.info(`Updated`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/ussd/ussdSvcCodes/${this.ussdSvcCode.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.ussdSvcCode.svcCode}`);
          this.router.navigate(["/ussdSvcCodes"]);
        }
      );
  }
}
